export type Credit = {
  last4: string;
  brand: string;
  expMonth: number;
  expYear: number;
  primaryCard: boolean;
  pmID: string;
};

/**
 * 支払いステータス定数
 */
export const PaymentStatus = {
  // 初期状態
  PENDING: "pending",

  // 3Dセキュア認証が必要
  REQUIRES_3DS: "requires_3ds",

  // オーソリ成功
  AUTHORIZED: "authorized",

  // 決済完了（キャプチャ済み）
  COMPLETED: "completed",

  // 決済失敗
  FAILED: "payment_failed",

  // 決済キャンセル
  CANCELED: "canceled",

  // 返金済み
  REFUNDED: "refunded",
} as const;

// TypeScriptの型定義
export type PaymentStatusType =
  (typeof PaymentStatus)[keyof typeof PaymentStatus];
